
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11193",
                "data-name": "矩形 11193",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(0.155 -0.422)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_234",
        "data-name": "蒙版组 234",
        "class": "cls-2",
        "transform": "translate(-0.155 0.422)"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "conferenceroom",
            "transform": "translate(2.315 3.473)"
          },
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7746",
                "data-name": "路径 7746",
                "class": "cls-3",
                "d": "M60.143,95.68A2.33,2.33,0,1,0,57.9,93.351,2.294,2.294,0,0,0,60.143,95.68Zm0-3.493a1.165,1.165,0,1,1-1.122,1.164A1.081,1.081,0,0,1,60.143,92.187Zm6.4,4.774a1.025,1.025,0,0,0-1.01-1.048H58.572a1.682,1.682,0,0,0-1.122.466,2.606,2.606,0,0,0-.561,1.4l.224,3.61a1.35,1.35,0,0,0,1.122,1.281l.224,4.425a.93.93,0,0,0,1.01.932H60.7a1.094,1.094,0,0,0,1.01-.932l.449-8.384,3.366-.582A1.223,1.223,0,0,0,66.538,96.961Zm-4.488.466a1.092,1.092,0,0,0-.9,1.048l-.449,8.267h-1.01l-.224-4.192a1.025,1.025,0,0,0-1.01-1.048.113.113,0,0,1-.112-.116l-.337-3.726a.438.438,0,0,1,.112-.349.4.4,0,0,1,.337-.116h5.161Zm5.273,1.747c.112.116.112.116.224.116a.246.246,0,0,0,.224-.233l1.122-2.212,1.01,1.048a.342.342,0,0,0,.224.116.388.388,0,0,0,.224-.116l1.907-3.377c.112-.116,0-.349-.112-.466s-.337,0-.449.116l-1.683,2.911-1.01-1.048a.4.4,0,0,0-.337-.116.246.246,0,0,0-.224.233l-1.122,2.212-.337-.349a.332.332,0,0,0-.449,0c0,.233,0,.349.112.466Z",
                "transform": "translate(-56.889 -91.022)"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7747",
                "data-name": "路径 7747",
                "class": "cls-3",
                "d": "M402.82,113.778h-9.689a.6.6,0,0,0,0,1.2h9.689a.515.515,0,0,1,.478.478v7.416a.515.515,0,0,1-.478.478h-9.689a.6.6,0,0,0,0,1.2h9.689a1.635,1.635,0,0,0,1.674-1.675v-7.416A1.711,1.711,0,0,0,402.82,113.778Z",
                "transform": "translate(-386.494 -113.299)"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  